import { delay, effects } from 'redux-saga'

import callWithHmac from 'internal-components/src/redux/sagas/effects/callWithHmac'

import { checkingEmail, checkedEmail } from '../../modules/signupEdit/actions'

export default function* checkEmail({ invocation }, { payload }) {
  let registered

  yield effects.call(delay, 250)

  try {
    yield effects.put.resolve(checkingEmail())
    registered = yield effects.call(
      callWithHmac,
      invocation.userRegistered,
      payload.email,
    )
  } finally {
    yield effects.put.resolve(checkedEmail(registered))
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/checkEmail.js